import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiProfileBarModule } from '../lib/shared-ui-profile-bar.module'
import { ProfileBarDocsComponent } from './profile-bar-docs/profile-bar-docs.component'
import { ProfileBarExampleComponent } from './profile-bar-docs/profile-bar-example.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiProfileBarModule
  ],
  declarations: [
    ProfileBarDocsComponent,
    ProfileBarExampleComponent
  ],
  exports: [
    ProfileBarDocsComponent
  ],
})
export class SharedUiProfileBarDocsModule {}
